<template>
    <div class="gateway-page">
        <top-bar class="topbar"></top-bar>

        <div class="gateway-content">
            <div class="text-title" v-html="lbl.gateway.text_title"></div>
            <div class="content-wrapper">
                <div class="text-content" v-html="lbl.gateway.smart_phone"></div>
                <div class="btn btn-register" @click="clickRegister()">ลงทะเบียน</div>
            </div>
            <div class="content-wrapper">
                <div class="text-content" v-html="lbl.gateway.computer"></div>

                <vue-qrcode id="qrcode" v-if="registerLink"
                    :value="registerLink"
                    :options="objQrCodeConfig">
                </vue-qrcode>

            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

import Vue from "vue";

import TopBar from "@/components/TopBar.vue";
import Locale from '@/helper/locale/locale.js';
import Account from "@/helper/AccountHelper.js";

import VueQrcode from '@chenfengyuan/vue-qrcode'; // https://github.com/fengyuanchen/vue-qrcode
import BzbsApi from "@/service/BzbsApi.js";

export default {
    name: "gatewaypage",
    components: {
        TopBar,
        VueQrcode
    },
    data: function() {
        return {

            lbl: Locale.getLbl(),
            registerLink: '',

            objQrCodeConfig: {
                width: 150
            },
        };
    },
    created: function() {

        this.getConfigRegister();
    },
    methods: {

        getConfigRegister: function () {
            var strBzbsToken = Account.getToken();
            var params = {};
            //var strUrl = BzbsApi.apiUrl + "/api/config/" + strConfig;
            var strUrl = Vue.bzbsConfig.newBzbsUrl + "/config/chanel_register";
            return new Promise(() => {
                BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params)
                .then((response) => {

                    this.registerLink = response.data.register.link;
                    console.log(this.registerLink);
                })
                .catch((error) => {
                    console.log(error);
                    if (!error.response) {
                    this.showErrorInternet();
                    }
                });
            });
        },

        clickRegister: function() {

            window.open(this.registerLink);

        }
    },
};
</script>
<style lang="scss" scoped>
    .gateway-page {
        min-height: 100vh;
        color: black;

        .gateway-content {
            padding: 10px;
            .text-title {
                font-size: 0.9rem;
                text-align: center;
            }
            .content-wrapper {
                padding-top: 75px;
                text-align: center;
                .text-content {

                    font-size: 0.8rem;
                    text-align: center;
                }
                .btn-register {
                    margin-top: 20px;
                    background-color: black;
                    color: white;
                    border-radius: 0;
                    font-size: 0.8rem;
                    padding: 8px 60px;
                }

                #qrcode {
                    margin-top: 10px;
                }
            }
            .content {
                font-size: 0.8rem;
                text-align: center;
                padding-top: 80px;
            }
        }
    }
</style>
